(function () {
  if (typeof document === "undefined") return;

  // Parse the GA4 client_id from the _ga cookie. Format: "GA1.<v>.<cid>.<ts>"
  // where the canonical client_id (what GA4 reads) is "<cid>.<ts>". If the
  // cookie is missing (ad-blocked / first visit / consent-denied), we let
  // audit-api synthesize one — the event still records, just without
  // session/source attribution.
  function gaClientId() {
    try {
      var match = document.cookie.match(/(?:^|;\s*)_ga=([^;]+)/);
      if (!match) return "";
      var parts = decodeURIComponent(match[1]).split(".");
      if (parts.length < 4) return "";
      return parts.slice(-2).join(".");
    } catch (e) {
      return "";
    }
  }

  document.addEventListener(
    "click",
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var link = t.closest(".audit-cta__btn");
      if (!link) return;

      var path = (window.location.pathname || "").toLowerCase();
      var slug = path.split("/").filter(Boolean).pop() || "";
      var h1 = document.querySelector("h1");
      var title = h1 ? (h1.textContent || "").trim() : "";
      var href = link.getAttribute("href") || "";

      var payload = JSON.stringify({
        article_slug: slug,
        article_title: title,
        href: href,
        path: path,
        client_id: gaClientId()
      });

      // sendBeacon survives navigation (the click is about to send the user
      // to /pages/audit). Fall back to fetch with keepalive if sendBeacon
      // is unavailable. Both paths are fire-and-forget — never block the nav.
      var url = "https://audit-api.weltpixel.com/cta-click";
      try {
        if (navigator.sendBeacon) {
          var blob = new Blob([payload], { type: "application/json" });
          navigator.sendBeacon(url, blob);
        } else if (window.fetch) {
          fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: payload,
            keepalive: true,
            credentials: "omit"
          }).catch(function () { /* swallow */ });
        }
      } catch (err) {
        /* swallow */
      }
    },
    true
  );
})();
